import type { PhoneCode } from '@/constants/phone-codes'
import { findCountryByCode } from './phone-code-auto-detect.helpers'

/**
 * Composable для автодетекту країни по коду телефону
 * При наборі номера, який починається з "+", знаходить максимально довгий код,
 * який відповідає введеним цифрам
 */
export function usePhoneCodeAutoDetect() {

  /**
   * Знаходить країну по введеному номеру телефону
   * @param phoneNumber - Номер телефону (наприклад: "+380634050445" або "+380")
   * @returns PhoneCode або null якщо не знайдено
   */
  const detectCountryByPhoneNumber = (phoneNumber: string): PhoneCode | null => {
    if (!phoneNumber?.startsWith('+')) {
      return null
    }

    const digitsOnly = phoneNumber.replace(/[^\d]/g, '')
    if (digitsOnly.length < 2) {
      return null
    }

    return findCountryByCode(digitsOnly)
  }

  return {
    detectCountryByPhoneNumber,
  }
}

